export default {
    language:'简体中文',
    // 导航
	zdy:{
        tjsq:"提交申请",
        czsl:"充值数量",
        enterczsl:"请输入充值数量",
        cz:"请输入充值数量{min}~{max}",
        qbdz:"钱包地址",
        enterqbdz:"请输入钱包地址",
        sftjmcj:"是否提交订单卖入价",
        sftjmrj:"是否提交订单买入价",
		proloss:'止盈止损',
	},
    header:{
        home:'首页',
        markets:'行情',
        fiat:'法币交易',
        c2c:'C2C交易',
        exchange:'币币交易',
        lever:'合约交易',
        micro:'秒合约交易',
        myshop:"我的商铺",
        assets:'我的资产',
        help:'帮助中心',
        login:"登录",
        sign:'注册',
        accountSet:'账户设置',
        tradeLog:'交易日志',
        receiveSet:'收款设置',
        identify:'身份认证',
        jchange:'币币兑换',
        logout:'退出登录',
       themedark:'夜间模式',
       themeday:'日间模式',
       bank:"绑定银行卡"
    },
    // 登录注册
    lg:{
        login:'登录',
        register:'注册',
    },
    // 首页
    home:{
        vol:'24H量',
        c01:'全球领先的数字资产交易平台',
        c02:'为全球超过130个国家的数百万用户提供安全、可信赖的数字资产交易及资产管理服务',
        c03:'安全可信赖',
        c04:'5 年数字资产金融服务经验',
        c05:'专业分布式架构和防 DDOS 攻击系统',
        c06:'全球生态布局',
        c07:'多个国家设立本土化交易服务中心',
        c08:'打造多业务形态为一体的区块链生态圈',
        c09:'用户至上',
        c10:'建立先行赔付机制',
        c11:'设立投资者保护基金',
        c12:'随时随地 多平台终端交易',
        c13:'覆盖iOS、Android、Windows多个平台，支持全业务功能',
        sweep:'扫码下载',
        android:'Android',
        pinput:'请输入你的邮箱或手机号',
        atrade:'注册一个ETHEREUM全球站账号 开始交易旅程',
        download:"下载APP",
        ios:"IOS 下载",
        androidDownload:"安卓下载"
    },
    // 底部
    foo:{
        about:'关于我们',
        support:'用户支持',
        contact:'联系我们',
        qq:'客服QQ',
        email:'联系邮箱',
    },
    // 行情
    market:{
		handicap:"盘口",
        exchange:'币币',
        selfmarket:'自选',
        allmarket:'全部行情',
        symbol:'交易对',
        newprice:'最新价',
        change:'涨幅',
        highprice:'最高价',
        lowprice:'最低价',
        vol:'24H量',
    },
    // 公共交易
    td:{
        buy:'购买',
        sell:'出售',
        currency:'币种',
        num:'数量',
        time:'时间',
        limit:'限额',
        price:'单价',
        method:'支付方式',
        total:'总额',
        inwant:'请输入欲',
        do:'操作',
        more:'加载更多',
        nomore:'没有更多了',
        nodata:'暂无数据',
        trade:'交易',
        buynum:'购买数量',
        sellout:'卖出',
        buyin:'买入',
        all:'全部',
        allbuy:'全部买入',
        allsell:'全部卖出',
        buytotal:'请输入欲购买总额',
        selltotal:'请输入欲出售总额',
        buyallnum:'请输入欲购买数量',
        sellallnum:'请输入欲出售数量',
        tradeTotal:'交易总额',
        doceil:'秒后自动取消',
        place:'下单',
        waitpay:'待付款',
        paycode:'付款码',
        finished:'已完成',
        ceiled:'已取消',
        payed:'已付款',
        nofinish:'未完成',   
        buyer:'买家',
        seller:'卖家',
        callWay:'联系方式',
        placeTime:'下单时间',
        renum:'参考号',
        canceil:'取消',
        confirm:'确认',
        pwd:'请输入交易密码',
        coincode:'货币单位',
        pcoin:'请选择货币单位'
    },
    // 法币交易
    fat:{
        // LegalPayDetail
        orderLog:'订单记录',
        fatdLog:'法币交易记录',
        shoper:'商家',
        faLog:'法币交易记录',
        tdType:'交易类型',
        odStatus:'订单状态',
        pwaitPay:'请等待买家付款',
        odFinish:'订单已完成',
        odCeil:'订单已取消',
        odPay:'已付款，请仔细查看支付信息',
        tdCeil:'取消交易',
        pCeil:'如您已向卖家付款请千万不要取消交易',
        paySure:'付款确认',
        pdopay:'请确认您已向卖家付款',
        badClick:'恶意点击将直接冻结账户',
        receivePay:'收款确认',
        payReceive:'请确认买家已向您付款',
        receivePays:'确认已收款',
        // LegalPay
        payPlease:'请付款',
        tdPrice:'交易单价',
        tdNum:'交易数量',
        payinfo:'付款信息',
        banknum:'银行账户',
        realName:'真实姓名',
        shoperZname:'商家支行',
        shoperNum:'商家账户',
        odCeil:'取消订单',
        imPay:'我已付款,点击确认',
        // LegalSeller
        register_time:'注册时间',
        odtotal:'总成单',
        odmonth:'30日成单',
        odfinish:'完成单',
        odrate:'完成率',
        submit:'发布',
        phone:'手机',
        mysell:'我的出售',
        mybuy:'我的求购',
        realAuth:'实名认证',
        advAuth:'高级认证',
        linebuy:'在线购买',
        linesell:'在线出售',
        tipPay:'请在24小时内联系商家付款，超出24小时将自动取消',
        notlow:'不能低于最低限额',
        nothigh:'不能超出最大限额',
        notnum:'不能超出最大数量',
        // LegalShopDetail
        type:'类型',
        status:'状态',
        seeOrder:'查看订单',
        withdraw:'撤回',
        abnormal:'异常',
        lowershelf:'下架',
        protection:'维权中',
		apply:'申请维权',
        psType:'请选择类型',
        pselect:'请选择',
        alipay:'支付宝',
        wechat:'微信',
        bank:'银行卡',
        minNum:'最小交易量',
        maxNum:'最大交易量',
        wantBuy:'求购',
        pnums:'请输入数量',
        pmin:'请输入最小交易量',
        pmax:'请输入最大交易量',
        pnot:'最大交易量不能小于最小交易量',
        // MyLegalShops
        myshops:'我的店铺',
        name:'名称',
        fiatSub:'所属法币',
        shoper_balance:'商家余额',
        enterShop:'进入店铺',
        // shop_legal_pay_detail
        payedWait:'已付款，等待核实后确认',
        yes:'是',
		no:'否',
		sd:'锁定余额',
		journal:'余额日志',
		business:'商家',
		user:'用户',
        backdone:'已撤回',
        busbalance:'商家余额',
		userbalance:'用户余额',
    },
    ctc:{
        ctc:'C2C',
        myRelease:'我发布的C2C',
        myTrade:'我交易的C2C',
        and:'对',
        balance:'余额',
        buynum:'买入量',
        sellnum:'卖出量',
        bankTransfer:'银行转账',
        payim:'必须本人支付',
        pbuyNum:'请输入买入数量',
        pprice:'请输入单价',
        payway:'请选择支付方式',
        psellNum:'请输入卖出数量',
        suerePlace:'确认下单么?',
        detail:'详情',
        payinfo:'付款信息',
        Payee:'收款人',
        total:'总额',
        name:'姓名',
        cardnum:'卡号',
        receivePay:'确认已收款',
        ceilConfirm:'确认取消交易？',
        paySeller:'请确认您已向卖家付款,恶意点击将被冻结账户',
        payBuyer:'请确认您已收买家付款信息',
        account:'账号',
        sellerPay:'请确认买家已向您付款？',
        payattion:'付款确认后请尽快向卖家付款,恶意点击将直接冻结账户',
        log:'c2c已完成订单',
    },
    // 合约
    lever:{
        nowentrust:'当前委托',
        hisentrust:'历史委托',
        lvchi:'合约持仓',
        all:'全部',
        or:'或',
        gotrade:'开始交易',
        tdrecord:'交易记录',
        dealed:'已成交',
        notdeal:'未成交',
        loading:'加载中...',
        entotal:'委托总额',
        canuse:'可用',
        std:'市价交易',
        xtd:'限价交易',
        pprice:'请输入价格',
        phand:'请输入购买手数',
        phandsell:'请输入出售手数',
        pwd:'密码',
        ppwd:'请输入交易密码',
        psw:'交易密码',
        equal:'等于',
        times:'倍',
        timed:'倍数',
        hand:'手',
        hands:'手数',
        ptimes:'请选择倍数',
        phands:'请选择手数',
        contractVal:'合约市值',
        bail:'保证金',
        canBail:'可用保证金',
        charge:'交易服务费',
        domore:'买入 (做多)',
        doshort:'卖出 (做空)',
        dmore:'做多',
        dshort:'做空',
        sureOd:'确认下单',
        noless:'手数不能低于',
        nomore:'手数不能高于',
        tdnum:'交易量',
        risk:'风险率',
        allloss:'持仓总盈亏',
        onehouse:'一键平仓',
        type:'类型',
        entrustPrice:'委托价',
        openPrice:'开仓价',
        nowPrice:'当前价',
        styPrice:'止盈价',
        stsPrice:'止损价',
        openTime:'开仓时间',
        closeTime:'平仓时间',
        rate:'手续费',
        nightFee:'隔夜费',
        loss:'盈亏',
        setloss:'设置止盈止损',
        expectProfit:'预期盈利',
        expectLoss:'预期亏损',
        allClose:'全部平仓',
        moreClose:'只平多单',
        nullClose:'只平空单',
        sureClose:'确认平仓？',
        thanZearo:'设置的值必须大于0',
        listin:'挂单中',
        tdin:'交易中',
        closein:'平仓中',
        closed:'已平仓',
        revoked:'已撤销',
        revokeOrder:'确认撤销订单么？',
        ping:'平仓',
        revoke:'撤单',
        sureping:'确定平仓？',
        thanzone:'设置的值必须大于0'
       
    },
    // 币币
    cuy:{
        direction:'方向',
        total:'总计',
        price:'价格',
        sell:'卖',
        buy:'买',
        allStation:'全站交易',
        buyPrice:'买入价',
        buynum:'买入量',
        sellPrice:'卖出价',
        sellnum:'卖出量',
        tdPrice:'交易额',
        or:'或',
        tdStart:'开始交易',
        pbPrice:'请输入买入价',
        pbNum:'请输入买入量',
        psPrice:'请输入卖出价',
        psNum:'请输入卖出量',
        fixPrice:'限价交易',
        Mtrans:'市价交易',
        available:'可用',
        revoke:'撤销',
        loading:'加载中',
        confirmCancel:'您确定要撤销吗？',
        confirm:'确定',
        cancel:'取消',
        nomore:'没有更多数据了',
        evelPrice:'成交均价'
    },
    // 资产
    asset:{
		confirmhuazhuan:"是否确认划转？",	
        assets:'资产',
        currency_account:'币币账户',
        lever_account:'合约账户',
        fince_account:'法币账户',
        change_account:'交易账户',
        micro_account:'秒合约账户',
        miscroAccount: '秒合约账户',
        assets_hua:'资金划转',
        all_assets:'总资产折合',
        currency:'币种',
        canuse:'可用',
        frezz:'冻结',
        conversion:'折合',
        charging:'充币',
        withdraw:'提币',
        address_bind:'绑定提币地址',
        address_withdraw:'提币地址管理',
        
        record:'明细',
        tbrecord:'提币记录',
        address_charge:'充币地址',
        address_width:'提币地址',
        copy:'复制',
        ercode:'二维码',
        reminder:'温馨提示',
        notcharge:'请勿向上述地址充值任何非',
        ornone:'，否则资产将不可找回',
        support:'充币仅支持simple send的方法，使用其他方法(send all) 的充币暂时无法上账，请谅解。',
        minnum:'最小提币数量{min}~{max}',
        ratenum:'手续费',
        havenum:'到账数量',
        from:'从',
        to:'至',
        transfer:'划转',
        tfnum:'划转数量',
        ptfnum:'请输入最低',
        dtfnum:'的划转数量',
        canbalance:'可用余额',
        sureConfirm:'确认划转',
        moneyRecord:'财务记录',
        pNum:'请输入划转数量',
        leverUse:'合约账户可用',
        legalUse:'法币账户可用',
		changeUselg:'币币账户可用',
        changeUse:'交易账户可用',
        microUse:'秒合约账户可用',
        look:'查看',
        chargeRecord:'充币记录',
        status:'跟踪状态',
        noopen:'该功能暂未开放',
        enterAdderses:'请输入提币地址',
        enterNum:'请输入提币数量',
        lessMin:'输入的提币数量小于最小值',
        tips01:'请勿向上述地址充值任何其他资产，否则资产将不可找回。',
        tips02:'充币仅支持simple send的方法，使用其他方法（send all）的充币暂时无法上账，请您谅解。',
        beizhu:'备注',
        pbeizhu:'请输入备注',
        add:'添加',
        addressList:'地址列表',
        delete:'删除',
        norec:'暂无记录',
        selectCurrency:'请选择币种',
        chainType:"链类型",
        ThreeChannel:"三方通道",
        AboutRate:"汇率{rate}约等于",
        OnlineBanking:"网银",
        ScanCode:"扫码"
    },
    // 账户设置
    set:{
        mycode2:'我的授权码',
        copycode2:'复制授权码',
        uaccont:'您的账号安全等级:',
        strong:'强',
        middle:'中',
        weak:'弱',
        min:'低',
        heigh:'高',
        complete:'完善更多资料，保证账号安全',
        mycode:'我的邀请码',
        copycode:'复制邀请码',
        bindphone:'绑定手机',
        bindemail:'绑定邮箱',
        loginpwd:'登录密码',
        noBind:'未绑定',
        binds:'绑定',
        bind:'去绑定',
        binded:'已绑定',
        net:'互联网账号存在被盗风险，建议您定期更改密码以保护账号安全。',
        reset:'修改',
        setPsw:'设置交易密码，保障交易安全。',
        goSet:'去设置',
        bindAccount:'绑定兑换账号',
        duihuan:'绑定账号进行积分兑换',
        copysuccess:'复制成功',
        copyfail:'复制失败',
        recopy:'请重新复制',
        account:'账户',
        detail:'详情',
        val:'金额',
        forgetPsw:'忘记密码',
        code:'验证码',
        getCode:'获取验证码',
        setPsw:'设置密码',
        enterPsw:'请输入密码',
        pswFalse:'两次输入的密码不一致',
        enterPswagain:'请再次输入密码',
        jsetPsw:'设置交易密码',
        jenterPsw:'请输入交易密码',
        jenterPswagain:'请再次输入交易密码',
        enterAccount:'请输入账号',
        enterCode:'请输入验证码',
        accountFalse:'您输入的手机或邮箱账号不符合规则!',
        second:'秒',
        sendCode:'发送验证码',
        sendsucc:'发送成功',
        enterPswTwo:'请输入两次密码',
        rest:'剩余',
        yes: '是',
        no: '否',
        yorn: '是否设置交易密码',
    },
    // 身份认证
    auth:{
        identity:'身份认证',
        name:'姓名',
        idcard:'身份证件',
        upimg:'请上传证件照，第一张为正面，第二张为反面,第三张为手持证件照正面照片。',
        submit:'提交',
        auditing:'审核中...',
        certified:'已认证!',
        pname:'请输入姓名',
        pidcard:'请输入证件号',
        pimg:'请上传证件图片!',
    },
    // 收款方式
    seting:{
        pmethod:'收款方式',
        truename:'真实姓名',
        opening:'开户行名称',
        bank:'银行卡号',
        alipay:'支付宝账号',
        wename:'微信昵称',
        wechat:'微信账号',
        pname:'请输入真实姓名',
        popen:'请输入开户行名称',
        pcard:'请输入银行卡号',
        palipay:'请输入支付宝账号',
        pwname:'请输入微信昵称',
        pwaccount:'请输入微信账号',
        pimg1:'微信收款码',
        pimg2:'支付宝收款码'
    },
    // 帮助中心
    news:{
        seeall:'查看全部',
        helpcenter:'公告中心',
        back:'返回'


    },
    //登录
    login:{
        welcome:'欢迎登录',
        phoneLogin:'手机登录',
        emailLogin:'邮箱登录',
        account:'账号',
        psw:'密码',
        login:'登录',
        nouser:'还不是ETHEREUM的用户？',
        goRegister:'立即注册，在全球领先的数字资产交易平台开始交易。',
        registerFree:'免费注册',
        psw6:'密码不能小于六位'
    },
    register:{
        register:'注册',
        phoneRegister:'手机注册',
        emailRegister:'邮箱注册',
        country:'国籍',
        enterPhone:'请输入手机号',
        enterEmail:'请输入邮箱',
        psw16:'密码在6-16位之间',
        inviteCode:'邀请码',
        sel:'必填',
        sel2:'非必填',
        read:'我已阅读并同意',
        xieyi:'《用户协议》',
        tips01:'国籍信息注册后不可修改，请务必如实选择。',
        tips02:'验证邮件可能会被误判为垃圾邮件，请注意查收。',
        tips03:'请妥善保存您的ETHEREUM账号及登录密码。',
        tips04:'请勿和其他网站使用相同的登录密码。',
        emailFalse:'您输入的邮箱不符合规则'
    },
    // 积分兑换
    jc:{
        title:'JC兑换数字资产BEAU平台',
        balance:'余额',
        cannum:'可用JC数量',
        new:'最新价',
        exnum:'兑换数量',
        pnum:'请输入JC数量',
        canex:'可兑换BEAU数量',
        exnow:'立即兑换',
        record:'兑换记录',
        exprice:'兑换价格',
        extime:'兑换时间',
        not:'可用积分数量不足',
        usenum:'使用JC数量',
        out:'退出',
        gotd:'去交易'

    },
    coin:{
        manage:'理财',
        total:'总存币',
        bao:'存币宝',
        mybao:'我的存币',
        profit:'预计收益',
        cuntime:'存币时间',
        endtine:'到期时间'
    },
    team:{
        myteam:'我的团队',
        ztnum:'直推人数',
        activenum:'团队活跃人数',
        profit:'收益',
        back:'返佣',
        cblog:'充币记录',
        bblog:'币币记录',
        
    },
     // k线
     kline: {
        text1: '分时',
        text2: '1分钟',
        text3: '5分钟',
        text4: '15分钟',
        text5: '30分钟',
        text6: '1小时',
        text7: '1天',
        text8: '1周',
        text9: '1月',
    },
    // 秒合约
    miscro: {
        trade: '交易中',
        buyPrice: '购买价',
        finshPrice: '成交价',
        loss: '预计盈亏',
        times: '倒计时',
        mode: '交易模式',
        num: '开仓数量',
        rate: '盈利率',
        up: '买涨',
        down: '买跌',
        openNum: '请输入开仓数量',
        success: '下单成功！',
        c2c: "C2C账户",
        complaint: "投诉建议",
        reply: "请写下您的问题，我们将尽快回复您...",
        complaintList: "投诉建议列表",
        complaintReply: "回复：",
        complaintDescription: "请输入描述内容",
        resetpwd: "修改密码",
        foundedOn: "创建于",
        commonProblem: "常见问题",
        statement: "解释说明",
        about: "关于ETHEREUM",
        everyone: "人人都是CEO",
        program: "ETHEREUM全球合伙人计划",
        program2: "合伙人计划",
        myMine: "我的矿场：",
        friend: "我的矿友：",
        myRank: "我的等级：",
        accumulated: "累计佣金：",
        copyLinks: "复制推广链接",
        moneyVein: "人脉变钱脉",
        example: "佣金示例",
        enterQuantity: "请输入数量",
        contractBalance: "合约账户余额",
        submitRepeatedly: "正在提交中，请不要反复提交",
        alipayCode: "支付宝付款码",
        wechatCode: "微信付款码",
        realPrice: "实时价格",
        currencyExchange: "兑出币种",
        currencyExchangeIn: "兑入币种",
        cashableBalance: "可兑出余额：",
        minimumCashable: "最小可兑出：",
        maximumCashable: "最大可兑出：",
        automaticallys: "点击兑换之后将自动完成，不能返回",
        match: "兑",
        title: "资产兑换",
        holdAssets: "持有资产",
        dangerousCurrency: "持险生币",
        convertibleQuantity: "可兑换数量",
        currencyExchanges: "币币兑换率：",
        insuranceCurrency: "保险币种",
        insuranceType: "保险类型",
        contractAsset: "合约资产保险额",
        warehouses: "保险仓数量",
        availableAssets: "可用资产：",
        insuredAssets: "受保资产：",
        insuredAssets1: "受保资产",
        insuranceAssets: "保险资产：",
        purchaseInsurance: "申购保险",
        insuranceClaims: "保险理赔",
        insuranceCancellation: "保险解约",
        coinWallet: "保险币钱包",
        bmbWallet: "HAP钱包",
        cumulativeCoins: "累计生币：",
        availableQuantity: "可用数量：",
        rawCurrency: "生币记录",
        contractInsurance:"合约保险",
        tenThousand:"万",
        runningLow:"余额不足",
        purchase:"你输入的数量不符合规则，你的购买额度在",
        reach:"到",
        between:"之间",
        onlyEnter:"你只能输入",
        integersBetween:"之间的整数",
        notReturned:"点击申购保险，视为详细了解保险条约并且同意保险仓自动生效，不能返回。",
        settled:"受保资产亏损至无法下单时，保险理赔",
        profitable:"倍，当资产盈利",
        terminated:"时，保险自动解约。",
        automatically:"当受保资产亏损50%时，必须申请保险理赔，否则无法交易，当盈利100%时，保险自动解约,保险仓每天只允许赔付两次，超过两次，t+1赔付",
        termination:"保险解约后，受保资产方可兑换，解约后视为违约，保险仓自动清零。",
        just:"正",
        back:"反",
        lowestNumber:"数量最低为",
        confirmExchange:"确认兑换吗?",
        contractValuation:"合约账户资产估值",
        secondValuation:"秒合约账户资产估值",
        falshValuation:"闪兑账户资产估值",
        c2cValuation:"C2C账户资产估值",
        recordWithdrawal:"充提币记录",
        category:"类别",
        safetyCenter:"安全中心",
        safeText1:"注册、修改密码，及安全设置时用以收取验证短信",
        safeText2:"互联网账号存在被盗风险，建议您定期更改密码以保护账户安全。",
        flashTrading:"闪兑交易",
        assetCenter:"资产中心",
        promotionCode:"我的推广码",
        loginAgain:"登录过时，请重新登录",
        text10:"基于HAP的实时价格",
        text11:"授权码"
    },
    bank:{
        BindingCard:"绑定银行卡",
        name:"姓名",
        PayeeName:"收款人姓名",
        bankName:"银行名称/银行编码",
        PayeeAdd:"收款地址",
        submit:"提交",
        fee:"收款",
        selectBank:"请选择银行"
    }

    
}


// WEBPACK FOOTER //
// ./src/lang/zh.js